import {
    animate,
    group,
    keyframes,
    query,
    stagger,
    state,
    style,
    transition,
    trigger,
} from '@angular/animations';

export const openClose = trigger('openClose', [
    state('false',style({transform: "translateX(100%)"})),
    state('true',style({transform: "translateX(0%)"})),
    transition('false => true', [
        animate(
            '0.3s ease-out',
            keyframes([
                style({transform: "translateX(100%)"}),
                style({transform: "translateX(0%)"})
            ])
        ),
    ]), 
    transition('true => false', [
        animate(
            '0.3s ease-out',
        )
    ])
])

export const changeBackgroundColorMenu = trigger('changeBackgroundColorMenu', [
    state('false',style({background: 'var(--light-blue)'})),
    state('true',style({background: 'var(--yellow)'})),
    transition('false => true', [
        animate(
            '0.3s ease-out',
            keyframes([
                style({background: 'var(--light-blue)'}),
                style({background: 'var(--yellow)'})
            ])
        ),
    ]), 
    transition('true => false', [
        animate(
            '0.3s ease-out',
        )
    ])
])

export const changeBackgroundColorPhoneNumberButtonMobile = trigger('changeBackgroundColorPhoneNumber', [
    state('false',style({background: 'var(--yellow)', right: '1.5625rem', bottom: '5.8125rem', zIndex: 2})),
    state('true',style({background: 'var(--light-blue)', top: '1.4781rem', left: '1.5625rem', zIndex: 6})),
    transition('false => true', [
        animate(
            '0.4s ease-out',
            keyframes([
                style({background: 'var(--yellow)', right: '1.5625rem', bottom: '5.8125rem', zIndex: 2}),
                style({background: 'var(--light-blue)', top: '1.4781rem', left: '1.5625rem', zIndex: 6})
            ])
        ),
    ]), 
    transition('true => false', [
        animate(
            '0.4s ease-out',
        )
    ])
])

export const openClosePhoneNumber = trigger('openClosePhoneNumber', [
    state('false',style({opacity: 0, display: 'none'})),
    state('true',style({opacity: 1, display: 'block'})),
    transition('false => true', [
        animate(
            '0.3s ease-out',
            keyframes([
                style({opacity: 0, display: 'none'}),
                style({opacity: 1,  display: 'block'})
            ])
        ),
    ]), 
    transition('true => false', [
        animate(
            '0.3s ease-out',
        )
    ])
])

export const changeBackgroundColorPhoneNumberButtonDesktop = trigger('changeBackgroundColorPhoneNumberDesktop', [
    state('false',style({background: 'var(--yellow)'})),
    state('true',style({background: 'var(--light-blue)'})),
    transition('false => true', [
        animate(
            '0.4s ease-out',
            keyframes([
                style({background: 'var(--yellow)'}),
                style({background: 'var(--light-blue)'})
            ])
        ),
    ]), 
    transition('true => false', [
        animate(
            '0.4s ease-out',
        )
    ])
])